import React from "react";

/**
 * AccessNova logo — uses the official PNG from /public/accessnova-logo.png.
 * The image already contains: A monogram + arrow, divider, "ACCESSNOVA"
 * wordmark, and the "ACCESSIBILITY. COMPLIANCE. IMPACT." tagline.
 *
 * Native aspect ratio: ~1215×280 (~4.34:1).
 *
 * Sizing: pass Tailwind height classes via `className` (e.g. "h-10 w-auto").
 */
export const Logo = ({ className = "h-10 w-auto" }) => (
    <img
        src="/accessnova-logo.png"
        alt="AccessNova — Accessibility. Compliance. Impact."
        className={className}
        width="1215"
        height="280"
        decoding="async"
        loading="eager"
    />
);

export default Logo;
